import React from "react";
import { Sidebar } from "flowbite-react";
import {
  HiOutlineLogout,
  HiOutlineHome,
  HiOutlineUserCircle,
  HiOutlineCreditCard,
  HiOutlineShoppingBag,
  HiOutlineTag,
  HiOutlinePhotograph,
  HiOutlineLink,
  HiOutlineQuestionMarkCircle,
  HiOutlineBell,
} from "react-icons/hi";
import { HiOutlineBuildingStorefront } from "react-icons/hi2";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../../actions/auth";
import {
  hasPlanAccess,
  hasStripeCustomer,
} from "../../utils/subscription";

const SidebarComponent = ({ isSidebarVisible, toggleSidebar }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const profile = useSelector((state) => state.user?.profile || null);
  const acessoPlano = hasPlanAccess(profile);
  const hasStripe = hasStripeCustomer(profile);
  const codigoPlanoAtual = profile?.permissoesPlano?.plano?.codigo || null;

  const destacarPlano = !acessoPlano || codigoPlanoAtual === "gratis";
  const rotuloPlano = acessoPlano
    ? "Plano"
    : hasStripe
    ? "Plano (Reativar)"
    : "Plano (Grátis)";

  const classePlano = !destacarPlano
    ? ""
    : !acessoPlano && hasStripe
    ? "animate-pulse bg-rose-50 ring-2 ring-rose-300 text-rose-800 rounded-lg"
    : "animate-pulse bg-amber-50 ring-2 ring-amber-300 text-amber-800 rounded-lg";

  const handleLogout = () => {
    navigate("/");
    toggleSidebar();
    dispatch(logout());
  };

  const handleCloseSidebar = () => {
    toggleSidebar();
  };

  return (
    <div
      className={`fixed top-0 h-full left-0 bg-white shadow-md transition-transform duration-300 z-40 ${
        isSidebarVisible ? "translate-x-0" : "-translate-x-full"
      } lg:relative lg:translate-x-0 lg:fixed lg:w-64`}
    >
      <Sidebar aria-label="Main navigation sidebar" className="h-full lg:mt-0 mt-12 ">
        <Sidebar.Items>
          <Sidebar.ItemGroup>
            <Sidebar.Item as={Link} to="/app/home" icon={HiOutlineHome} onClick={handleCloseSidebar}>
              Home
            </Sidebar.Item>
            <Sidebar.Item
              as={Link}
              to="/app/user"
              icon={HiOutlineUserCircle}
              onClick={handleCloseSidebar}
            >
              Perfil
            </Sidebar.Item>

            <Sidebar.Item
              as={Link}
              to="/app/loja"
              icon={HiOutlineBuildingStorefront}
              onClick={handleCloseSidebar}
            >
              Loja
            </Sidebar.Item>
            <Sidebar.Item
              as={Link}
              to="/app/produtos"
              icon={HiOutlineShoppingBag}
              onClick={handleCloseSidebar}
            >
              Produtos
            </Sidebar.Item>
            <Sidebar.Item
              as={Link}
              to="/app/fotos"
              icon={HiOutlinePhotograph}
              onClick={handleCloseSidebar}
            >
              Fotos
            </Sidebar.Item>
            <Sidebar.Item as={Link} to="/app/tags" icon={HiOutlineTag} onClick={handleCloseSidebar}>
              Tags
            </Sidebar.Item>
            <Sidebar.Item as={Link} to="/app/link" icon={HiOutlineLink} onClick={handleCloseSidebar}>
              Gerar Link
            </Sidebar.Item>
            <Sidebar.Item
              as={Link}
              to="/app/notificacoes"
              icon={HiOutlineBell}
              onClick={handleCloseSidebar}
            >
              Notificações
            </Sidebar.Item>

            <Sidebar.Item
              as={Link}
              to="/app/planos"
              icon={HiOutlineCreditCard}
              onClick={handleCloseSidebar}
              className={classePlano}
            >
              {rotuloPlano}
            </Sidebar.Item>
            <Sidebar.Item
              as={Link}
              to="/app/ajuda"
              icon={HiOutlineQuestionMarkCircle}
              onClick={handleCloseSidebar}
            >
              Ajuda
            </Sidebar.Item>

            <Sidebar.Item as={Link} onClick={handleLogout} icon={HiOutlineLogout}>
              Logout
            </Sidebar.Item>
          </Sidebar.ItemGroup>
        </Sidebar.Items>
      </Sidebar>
    </div>
  );
};

export default SidebarComponent;
